import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const fmt = (n) => Number(n || 0).toLocaleString("en-ZA", { maximumFractionDigits: 2 });

export default function ConfirmTransferDialog({ open, onOpenChange, rows, from, to, notes, busy, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
      <DialogContent className="sm:max-w-xl max-h-[90vh] overflow-y-auto" data-testid="transfer-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Confirm transfer</DialogTitle>
          <DialogDescription>{from} → {to}. Stock leaves {from} and arrives in {to} in one step. Selling prices are not changed.</DialogDescription>
        </DialogHeader>
        <div className="border rounded-md divide-y text-sm">
          {rows.map((r) => (
            <div key={r.product_id} className="p-2" data-testid={`transfer-confirm-line-${r.sku}`}>
              <div className="flex justify-between gap-2"><span className="truncate">{r.name}</span><b className="font-mono shrink-0">{fmt(r.q)} {r.unit}</b></div>
              <div className="font-mono text-[11px] text-muted-foreground">{from}: {fmt(r.source_qty)} → {fmt(r.source_qty - r.q)} (−{fmt(r.q)}) · {to}: {fmt(r.dest_qty)} → {fmt(r.dest_qty + r.q)} (+{fmt(r.q)})</div>
            </div>
          ))}
        </div>
        {notes && <div className="text-xs text-muted-foreground">Notes: {notes}</div>}
        <DialogFooter>
          <Button variant="ghost" disabled={busy} onClick={() => onOpenChange(false)}>Back</Button>
          <Button className="rounded-full" disabled={busy} onClick={onConfirm} data-testid="transfer-confirm-btn">{busy ? "Transferring…" : "Confirm transfer"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
